
import Redo from "../../../assets/outline/Redo.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RedoIcon({ className, dataTestid = "RedoIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Redo data-testid={dataTestid} className={classes} {...rest} />
  );
}
